import { FormDataAddress } from "../Onboarding/components/FormPartialAddress";

/** Work sites back W-2 reporting, which is US-only — so is the address form. */
export const WORKSITE_COUNTRY = "US";

export type FormDataWorksite = {
  name: string;
  address: FormDataAddress;
  externalId: string;
  isPrimary: boolean;
};
